
import axios from'../utils/axiosConfig'; // runs the 401/403 logout logic globally
import React, { useEffect, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import Modal from './Modal';
import "../Style/EmailVerification.css";
import "../Style/Responsive.css";

 
const EmailVerification = () => {
  const { token } = useParams();  // Extract token from URL params
  const location = useLocation();  // To access the state passed from registration page
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [verificationCode, setVerificationCode] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [timer, setTimer] = useState(30);  // Countdown timer for resend button
  const [canResend, setCanResend] = useState(false);  // Disable/enable resend button
  const [email] = useState(location.state?.email || ''); // Get email passed via state
 
  // Verify email when the component is mounted or token changes
  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/verify/${token}/`);
        setMessage(response.data.message);
        setIsVerified(true);  // Set as verified on successful response
      } catch (error) {
        setError(error.response ? error.response.data.error : 'Something went wrong!');
      }
    };
 
    verifyEmail();
 
    // Start countdown timer for resend button
    const interval = setInterval(() => {
      setTimer(prevTimer => {
        if (prevTimer <= 1) {
          clearInterval(interval);
          setCanResend(true);  // Enable resend button when timer finishes
        }
        return prevTimer - 1;
      });
    }, 1000);
 
    return () => clearInterval(interval);  // Cleanup on unmount
  }, [token]);
 
  // Handle change in verification code input
  const handleCodeChange = (e) => {
    setVerificationCode(e.target.value);
  };
 
  // Verify the entered verification code
  const handleVerify = async () => {
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/verify/code/`, {
        token: token,
        code: verificationCode,  // Send token and entered code to the backend
      });
      setMessage(response.data.message);  // Display success message
      setIsVerified(true);  // Indicate successful verification
    } catch (error) {
      setError(error.response ? error.response.data.error : 'Verification failed!');
    }
  };
 
  // Handle resend code functionality
  const handleResendCode = async () => {
    if (!canResend) return;  // Prevent multiple requests before timer expires
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/resend-verification-code/`, {
        token: token,  // Sending token to resend the verification code
      });
      setMessage(response.data.message);  // Display success message
      setTimer(30);  // Reset timer after resend
      setCanResend(false);  // Disable resend button until timer is up
    } catch (error) {
      setError(error.response ? error.response.data.error : 'Failed to resend the verification code.');
    }
  };
 
  return (
    <div className="verification-container">
      <h2>Email Verification</h2>
 
      {/* Show the success or error modal */}
      <Modal message={message} onClose={() => setMessage('')} />
      <Modal message={error} onClose={() => setError('')} />
 
      {/* Main Verification Section */}
      {!isVerified ? (
        <>
          <div className="verification-header">
            <span>Enter verification code sent to your email:</span>
            <strong>{email}</strong> {/* Display the user's email */}
          </div>
         
          <div className="verification-input-section">
            <input
              type="text"
              placeholder="Enter verification code"
              value={verificationCode}
              onChange={handleCodeChange}
              className="verification-input"
            />
            <button onClick={handleVerify} className="submit-btn">
              Verify Code
            </button>
          </div>
         
          <div className="timer-section">
            <button
              onClick={handleResendCode}
              disabled={!canResend}
              className="resend-btn"
            >
              {canResend ? 'Resend Code' : `Resend in ${timer}s`}
            </button>
          </div>
        </>
      ) : (
        <div className="success-message">{message}</div>
      )}
    </div>
  );
};
 
export default EmailVerification;